 const postBackgroundsData = [
 "../../../images/postbackgrounds/1.jpg",
 "../../../images/postbackgrounds/2.jpg",
 "../../../images/postbackgrounds/3.jpg",
 "../../../images/postbackgrounds/4.jpg",
 "../../../images/postbackgrounds/5.jpg",
 "../../../images/postbackgrounds/6.jpg",
 "../../../images/postbackgrounds/7.jpg",
 "../../../images/postbackgrounds/8.jpg",
 "../../../images/postbackgrounds/9.jpg",
];

export default postBackgroundsData